import Blank from "@/layouts/blank.vue";
import DebitNoteList from "@/pages/admin/invoice/debit-note/DebitNoteList.vue";
import DebitNoteAdd from "@/pages/admin/invoice/debit-note/DebitNoteAdd.vue";

const debitNoteRoutes = [
  {
    path: "debit-note",
    name: "app-admin-invoice-debit-note",
    component: Blank,
    children: [
      {
        path: "/",
        redirect: "/app/admin/invoice/debit-note/list",
      },
      {
        path: "list",
        name: "app-admin-invoice-debit-note-list",
        component: DebitNoteList,
      },
      {
        path: "add",
        name: "app-admin-invoice-debit-note-add",
        component: DebitNoteAdd,
      },
    ],
  },
];

export default debitNoteRoutes;
